import type { Context } from './MiddlewareInterface';
import { useAuthStore } from '@/stores/useAuthStore';

export default async function LogoutMiddleware({ to }: Context) {
  const authStore = useAuthStore();
  await authStore.$persistedState.isReady();

  if (to.name === 'Logout') {
    authStore.resetData();
  }
};
